import { Model, attr, belongsTo } from '@elatonsev/js-models';
import ServiceModel from './ServiceModel';

export default class ReservationServiceModel extends Model {
  duration = attr('number');
  price = attr('number');
  service = belongsTo(ServiceModel);
}